import type { RouteRecordRaw } from 'vue-router';

const publicRoutes: RouteRecordRaw = {
    path: '/',
    meta: {
        guest: true
    },
    children: [
        {
            path: '/',
            name: 'landing',
            redirect: '/auth/login'
        },
        {
            path: '/pages/notfound',
            name: 'notfound',
            component: () => import('@/views/pages/NotFound.vue')
        },
        {
            path: '/auth/login',
            name: 'login',
            component: () => import('@/views/pages/auth/Login.vue')
        },
        {
            path: '/auth/forgot-password',
            name: 'forgot-password',
            component: () => import('@/views/pages/auth/ForgotPassword.vue')
        },
        {
            path: '/auth/reset-password',
            name: 'reset-password',
            component: () => import('@/views/pages/auth/ResetPassword.vue')
        },
        {
            path: '/auth/callback',
            name: 'validate-token',
            component: () => import('@/views/pages/auth/ValidateToken.vue')
        },
        {
            path: '/auth/access',
            name: 'accessDenied',
            component: () => import('@/views/pages/auth/Access.vue')
        },
        {
            path: '/auth/error',
            name: 'error',
            component: () => import('@/views/pages/auth/Error.vue')
        }
    ]
};

export default publicRoutes;